<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-8">
                  <h4 class="card-title">Müşteriler</h4>
                  <p class="card-category">Bayilerinizin müşterilerini buradan daha kolay yönetebilirsiniz. Oynama
                    Cirolarını ve Bonuslarını buradan daha kolay görüntüleyebilirsiniz. Eklemek için haftalık raporu
                    yükleyiniz.</p>
                </div>

              </div>

              <div class="row m-5 justify-content-center align-items-center">
                <div class="col-12 d-flex justify-content-center align-items-center">

                  <button class="btn mr-2 mb-2"
                    :class="{ 'btn-primary btn-fill': selectedDealerId === null, 'btn-outline-primary': selectedDealerId !== null }"
                    @click="selectDealer(null)">Tüm Bayiiler</button>

                  <button class="btn mr-2 mb-2" v-for="dealer in dealers" :key="dealer._id"
                    @click="selectDealer(dealer._id)"
                    :class="{ 'btn-primary btn-fill': selectedDealerId === dealer._id, 'btn-outline-primary': selectedDealerId !== dealer._id }">
                    {{ dealer.title }} ({{ dealer.code }})
                  </button>
                </div>
              </div>

              <!-- Yeni rapor seçim alanı -->
              <div class="row m-3 justify-content-center align-items-center">
                <div class="col-4">
                  <select class="form-control" v-model="selectedWeek" @change="getCustomers">
                    <option value="">Tüm Zamanlar</option>
                    <option v-for="week in weeks" :key="week.id" :value="week.value">
                      {{ week.title }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row p-3">
                <div class="col-3 ml-2">
                  <input class="form-control form-control-lg bg-light text-dark " @input="debounceGetCustomers"
                    v-model="queryText" type="text" placeholder="Arama">
                </div>

              </div>


            </template>
            <h2 class="text-center text-danger" style="font-weight: bold;">Dikkat </h2>
            <h3 v-if="selectedWeek" class="text-center" style="font-weight: bold;">Gösterilen Veriler, {{
              weeks.find(week =>
                week.value === selectedWeek).title}} isimli hafta için verilerdir. <span class="text-danger"> Haftalık
                bonus
                yükleme için
                burayı kullanmayınız.</span> </h3>
            <h3 v-else class="text-center" style="font-weight: bold;">Gösterilen Veriler, Tüm Zamanlar için verilerdir.
              Oyuncuların,
              yüklediğiniz raporların tümünü toplayarak hesaplanmıştır. <span class="text-danger"> Haftalık bonus
                yükleme için
                burayı kullanmayınız.</span> </h3>

            <div v-if="customersLoading === true">
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title text-center">Yükleniyor...</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <table class="table table-hover table-striped" v-if="customersLoading === false">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(customer) in customers" :key="customer._id">
                  <slot :row="customer">
                    <td>{{ customer.gsm }}</td>
                    <td>{{ customer.name }} {{ customer.surname }}</td>
                    <td>{{ customer.dealer ? customer.dealer.title + ' (' + customer.dealer.code + ')' : '-' }}</td>
                    <td>{{ customer.totalDeposit && customer.totalDeposit.length > 0 ?
                      numeral(customer.totalDeposit[0].totalAmount).format('0,0.00') + 'TL' : '-' }}</td>
                    <td>{{ customer.totalConversion && customer.totalConversion.length > 0 ?
                      numeral(customer.totalConversion[0].totalAmount).format('0,0.00') + ' TL'
                      :
                      '-' }}</td>
                    <td>{{ customer.totalConversion && customer.totalConversion.length > 0 ?
                      numeral(customer.totalConversion[0].totalRefundedAmount).format('0,0.00') + ' TL'
                      :
                      '-' }}</td>

                    <td>{{ customer.totalConversion && customer.totalConversion.length > 0 ?
                      numeral(customer.totalConversion[0].totalAmount - customer.totalConversion[0].totalRefundedAmount
                      ).format('0,0.00') + ' TL'
                      :
                      '-' }}</td>

                    <td>
                      <router-link :to="`/admin/customers/${customer._id}`" target="_blank">
                        <button><i class="nc-icon nc-align-left-2"></i></button>
                      </router-link>
                    </td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)" :key="i"><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";
import moment from 'moment';
import numeral from 'numeral';


const tableColumns = ['Tel No', 'İsim Soyisim', 'Bayii', 'Toplam Yükleme', 'Toplam Çevirim', 'Toplam İade Tutarı', "Net Çevirim"]
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      customers: [],
      dealers: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10000,
        layOutMax: 3
      },
      queryText: '',
      searchInterval: null,
      selectedDealerId: null,
      numeral,
      weeks: [],
      selectedWeek: null,
      customersLoading: true
    }
  },
  mounted() {
    this.generateWeeks();
    this.getCustomers();
    this.getDealers();
  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getCustomers();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getCustomers() {
      this.customersLoading = true;
      let q = {
        $or: [
          { gsm: { $regex: this.queryText, $options: 'i' } },
          { name: { $regex: this.queryText, $options: 'i' } },
          { surname: { $regex: this.queryText, $options: 'i' } }
        ]
      };


      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      if (this.selectedDealerId) {
        query += `&dealerId=${this.selectedDealerId}`;
      }
      if (this.selectedWeek) {
        query += `&week=${this.selectedWeek}`;
      }

      CollectionService.getCollection('customer', query).then((res) => {
        if (res.success == true) {
          this.customers = res.customers;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      }).finally(() => {
        this.customersLoading = false;
      })
    },
    editCustomer(_id) {
      this.$router.push(`/admin/customers/${_id}`);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    debounceGetCustomers() {
      if (this.searchInterval) {
        clearTimeout(this.searchInterval);
      }
      this.searchInterval = setTimeout(() => {
        this.getCustomers();
      }, 250);
    },
    selectDealer(dealerId) {
      this.selectedDealerId = dealerId;
      this.getCustomers();
    },
    generateWeeks() {
      const weeks = [];
      let currentDate = new Date();

      // Find the most recent Tuesday
      while (currentDate.getDay() !== 2) { // 2 represents Tuesday
        currentDate.setDate(currentDate.getDate() - 1);
      }

      // Generate 12 weeks
      for (let i = 0; i < 36; i++) {
        const endDate = new Date(currentDate);
        const startDate = new Date(currentDate);
        startDate.setDate(startDate.getDate() - 7); // Go back 6 days for the previous Tuesday

        const formattedStartDate = startDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        const formattedEndDate = endDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });

        weeks.push({
          id: i,
          title: `${formattedStartDate} - ${formattedEndDate}`,
          startDate: startDate,
          endDate: endDate,
          value: moment(startDate).format('DDMMYYYY')
        });

        // Move to the previous week
        currentDate.setDate(currentDate.getDate() - 7);
      }

      this.weeks = weeks;
      this.selectedWeek = this.weeks[0].value; // Select the most recent week by default
    },
    getDealers() {
      let q = {};
      let p = {};
      let o = { skip: 0, limit: 10000, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('dealer', query).then((res) => {
        this.dealers = res.dealers;
      })
    }
  }
}
</script>
<style></style>